import { render, staticRenderFns } from "./categoryEditModal.vue?vue&type=template&id=4b3fd93d&scoped=true&"
import script from "./categoryEditModal.vue?vue&type=script&lang=js&"
export * from "./categoryEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fd93d",
  null
  
)

export default component.exports